import React from 'react'
import { Form } from 'semantic-ui-react'

export default class AddressField extends React.PureComponent {
  render() {
    const { value, onChange, required } = this.props

    return (
      <Form.TextArea
        label="Address"
        required={required}
        placeholder="e.g St.102, #28, PP...."
        onChange={e => onChange('address', e.target.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/addressField.js